(() => {
  'use strict';
  if (window.TPV20ExternalDemandInstaller) return;

  const install = () => {
    const base = window.TPV20BestellpilotEngine;
    if (!base) return false;
    if (base.__externalDemandAdapter === true) return true;

    const n = (value, fallback = 0) => base.n(value, fallback);

    const calculate = (mode, usecase, input, config, now = new Date()) => {
      const original = base.calculate(mode, usecase, input, config, now);
      const externalBaseKg = Math.max(0, n(input?.externalBaseKg, 0));
      if (mode !== 'planner' || externalBaseKg <= 0) return original;

      const safetyRate = Number(config.safetyRates?.[input.safety] ?? config.safetyRates?.prime ?? 0.12);
      const useSafety = externalBaseKg * safetyRate;
      const needAtUse = externalBaseKg + useSafety;
      const retention = Math.max(0.01, Number(original.storageRetention || 1));
      const gross = needAtUse / retention;
      const storageReserve = Math.max(0, gross - needAtUse);
      const toleranceRate = Number(config.plannerToleranceRate || 0);
      const toleranceReserve = gross * toleranceRate;
      const required = gross + toleranceReserve;

      const cfg = {
        ...original.cfg,
        name: String(input.externalLabel || original.cfg?.name || 'Spezialbedarf'),
        reason: String(input.externalReason || original.cfg?.reason || '')
      };

      return {
        ...original,
        cfg,
        calc: {
          base: externalBaseKg,
          tempSurcharge: 0,
          conditionReserve: 0,
          builtIn: 0,
          total: externalBaseKg
        },
        useSafety,
        needAtUse,
        storageReserve,
        toleranceReserve,
        required,
        scenarios: null,
        externalBase: true,
        externalBaseKg
      };
    };

    const resultWithChoices = (mode, usecase, input, config, products, selectedChoice = 'recommended', now = new Date()) => {
      const externalBaseKg = Math.max(0, n(input?.externalBaseKg, 0));
      if (mode !== 'planner' || externalBaseKg <= 0) {
        return base.resultWithChoices(mode, usecase, input, config, products, selectedChoice, now);
      }

      const result = calculate(mode, usecase, input, config, now);
      result.inputSafety = input.safety;
      const choiceState = base.buildChoices(result, products?.[result.productKey], config, selectedChoice);
      const plan = base.selectedPlan(choiceState);
      const b2bKg = Math.max(Number(result.required || 0), Number(plan?.totalKg || 0));
      return {
        ...result,
        choiceState,
        plan,
        b2bRequired: b2bKg > Number(config.b2bThresholdKg || 420.2),
        b2bKg
      };
    };

    window.TPV20BestellpilotEngine = Object.freeze({
      ...base,
      calculate,
      resultWithChoices,
      __externalDemandAdapter: true
    });
    window.dispatchEvent(new CustomEvent('tpv20:external-demand-ready'));
    return true;
  };

  window.TPV20ExternalDemandInstaller = Object.freeze({ install });
  if (install()) return;

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (install() || attempts >= 200) window.clearInterval(timer);
  }, 20);
})();
